import {useContext, useEffect, useState} from "react";
import LoadingScreen from "../../LoadingScreen";
import {IoCheckmarkSharp} from "react-icons/io5";
import OTP from "../../OTP";
import AuthenticationServiceContext from "../../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import handleGenerateUuid from "../../../tools/api/global/generateUuid";
import Api from "../../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../modals/ErrorModal";
import {persianToEnglish} from "../../../tools/helpers";
import REQUEST_URLS from "../../../tools/defaults/requestUrl";

const defaultSteps = {
    "LOGIN_BUSINESS_LICENSE": "LoginBusinessLicense",
    "VERIFY_BUSINESS_LICENSE_OTP": "VerifyBusinessLicenseOTP",
    "PASSWORD_BUSINESS_LICENSE": "PasswordBusinessLicense"
};

const TimeLine = ({currentStep}) => {
    return <div className="flex bg-white mb-5 py-3 rounded-xl   justify-center items-center">
        <div
            className={`flex justify-start items-center ${currentStep === defaultSteps.VERIFY_BUSINESS_LICENSE_OTP ? '' : 'opacity-30'}`}>
            <span
                className="rounded-full bg-green-500 text-white text-sm h-8 w-8 justify-center items-center flex">{currentStep === defaultSteps.VERIFY_BUSINESS_LICENSE_OTP ?
                <span>{1}</span> : <IoCheckmarkSharp className="text-white"/>}</span>
            <h1 className="mx-2">مرحله اول</h1>

        </div>
        <div
            className={`flex items-center justify-center ${currentStep === defaultSteps.VERIFY_BUSINESS_LICENSE_OTP ? 'opacity-30' : ''}`}>
            <div className="w-20 h-1 bg-green-300 mx-3 rounded-lg"/>
            <div className="flex flex justify-start items-center">
                <span className="rounded-full bg-green-500 text-white text-sm h-8 w-8 flex justify-center items-center"><span>{2}</span></span>
                <h1 className="mx-2">مرحله دوم</h1>

            </div>
        </div>
    </div>
}
const BusinessLicenseOTP = (props) => {
    const serviceContext = useContext(AuthenticationServiceContext);
    const [firstOTP, setFirstOTP] = useState(null)
    const [currentStep, setCurrentStep] = useState(defaultSteps.LOGIN_BUSINESS_LICENSE);
    const [requestLoading, setRequestLoading] = useState(false)
    const [verifyRequest, setVerifyRequest] = useState(false)
    const [loading, setLoading] = useState(true);
    const handleLoginBusinessLicense = (clicked) => {
        if (clicked) {
            setRequestLoading(true)
        } else {
            setLoading(true);
        }

        handleGenerateUuid('LoginBusinessLicense', serviceContext.token).then(uuid => {
            if (uuid) {
                Api.post(REQUEST_URLS.AUTHENTICATION.LOGIN_BUSINESS_LICENSE, {
                    uuid, pid: serviceContext.pid,
                }, {
                    headers: {
                        "Authorization": `Bearer ${serviceContext.token}`
                    }
                }).then(response => {
                    const {data, hasError, message, status} = response;
                    if (clicked) {
                        setRequestLoading(false)
                    } else {
                        setLoading(false);
                    }
                    if (hasError) {
                        if (data && data?.should_skip) {
                            serviceContext.handleGetProcess(serviceContext.pid)
                        } else {

                            serviceContext.handleError({
                                status,
                                message,
                                data,
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                showConfirmButton: false,
                                onCancel: () => {
                                    handleLoginBusinessLicense();
                                },
                                callback: () => {
                                    Reoverlay.showModal(ErrorModal, {
                                        title: 'خطا',
                                        message: message || 'خطای دسترسی',
                                        showConfirmButton: data?.can_reset,
                                        confirmButtonText: 'ویرایش اطلاعات',
                                        confirmButtonTheme: "light",
                                        showCancelButton: true,
                                        cancelButtonText: 'تلاش مجدد',
                                        cancelButtonTheme: 'red',
                                        pid: serviceContext.pid,
                                        onConfirm: () => {
                                            if (data.can_reset) {
                                                serviceContext.handleReset();
                                            }
                                            Reoverlay.hideModal();
                                        },
                                        onCancel: () => {
                                            Reoverlay.hideModal();
                                            handleLoginBusinessLicense()
                                        }
                                    })
                                }
                            })
                        }

                    } else {
                        if (data?.should_skip) {

                            serviceContext.handleGetProcess(serviceContext.pid)
                        } else {
                            setLoading(false)
                            setCurrentStep(defaultSteps.VERIFY_BUSINESS_LICENSE_OTP)
                        }

                    }
                }).catch(e => {

                })
            } else {
                handleLoginBusinessLicense()
            }
        }).catch(e => {

        })

    }
    const handleVerifyBusinessLicenseOTP = (OTP) => {
        setFirstOTP(OTP)
        setVerifyRequest(true);
        handleGenerateUuid('VerifyBusinessLicenseOTP', serviceContext.token).then(uuid => {
            if (uuid) {
                Api.post(REQUEST_URLS.AUTHENTICATION.VERIFY_BUSINESS_LICENSE_OTP, {
                    uuid, pid: serviceContext.pid, OTP: persianToEnglish(OTP),
                }, {
                    headers: {
                        "Authorization": `Bearer ${serviceContext.token}`
                    }
                }).then(response => {
                    const {data, hasError, message, status} = response;
                    setVerifyRequest(false);
                    if (hasError) {
                        serviceContext.handleError({
                            status,
                            message,
                            data,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            showConfirmButton: false,
                            onCancel: () => {
                                setLoading(true);
                                setCurrentStep(defaultSteps.LOGIN_BUSINESS_LICENSE)
                            },
                            callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message,
                                    showConfirmButton: true,
                                    confirmButtonText: 'تلاش مجدد',
                                    confirmButtonTheme: 'red',
                                    showCancelButton: false,
                                    onConfirm: () => {
                                        handleLoginBusinessLicense();
                                        Reoverlay.hideModal()
                                    }
                                })
                            }
                        })
                    } else {
                        if (data?.should_skip) {
                            serviceContext.handleGetProcess(serviceContext.pid)
                        } else {
                            setLoading(false)
                            setCurrentStep(defaultSteps.PASSWORD_BUSINESS_LICENSE)
                        }

                    }
                }).catch(e => {

                })
            } else {
                handleLoginBusinessLicense()
            }
        }).catch(e => {

        })
    }
    const handlePasswordBusinessLicense = (OTP) => {
        setVerifyRequest(true);
        handleGenerateUuid('PasswordBusinessLicense', serviceContext.token).then(uuid => {
            if (uuid) {
                Api.post(REQUEST_URLS.AUTHENTICATION.PASSWORD_BUSINESS_LICENSE, {
                    uuid, pid: serviceContext.pid, OTP: persianToEnglish(OTP),
                }, {
                    headers: {
                        "Authorization": `Bearer ${serviceContext.token}`
                    }
                }).then(response => {
                    const {data, hasError, message, status} = response;
                    setVerifyRequest(false);
                    if (hasError) {

                        serviceContext.handleError({
                            status,
                            message,
                            data,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            showConfirmButton: false,
                            onCancel: () => {
                                setLoading(true);
                                setCurrentStep(defaultSteps.LOGIN_BUSINESS_LICENSE)
                            },
                            callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message,
                                    showConfirmButton: true,
                                    confirmButtonText: 'تلاش مجدد',
                                    confirmButtonTheme: 'red',
                                    showCancelButton: false,
                                    onConfirm: () => {
                                        handleLoginBusinessLicense();
                                        Reoverlay.hideModal()
                                    }
                                })
                            }
                        })
                    } else {
                        serviceContext.handleGetProcess(serviceContext.pid)

                    }
                }).catch(e => {

                })
            } else {
                handleLoginBusinessLicense()
            }
        }).catch(e => {

        })
    }

    useEffect(() => {
        if (currentStep === defaultSteps.LOGIN_BUSINESS_LICENSE) {
            handleLoginBusinessLicense()
        }
    }, [currentStep]);
    if (loading) {
        return <LoadingScreen text={'لطفا منتظر بمانید.'}/>
    }
    return <div>
        <div className="p-5 ">
            {(currentStep === defaultSteps.VERIFY_BUSINESS_LICENSE_OTP || currentStep === defaultSteps.PASSWORD_BUSINESS_LICENSE) &&
                <TimeLine currentStep={currentStep}/>}
            {currentStep === defaultSteps.VERIFY_BUSINESS_LICENSE_OTP &&
                <OTP title="کد اعتبار سنجی برای شما ارسال شد." verifyOTPLoading={verifyRequest}
                     requestOTPLoading={requestLoading}
                     description={`لطفا کد اعتبار سنجی  برای شماره ${serviceContext.process.platform_user} را وارد کنید.`}
                     handleVerify={handleVerifyBusinessLicenseOTP}
                     handleRequest={() => handleLoginBusinessLicense(true)} timerCount={120}/>}

            {currentStep === defaultSteps.PASSWORD_BUSINESS_LICENSE && <>
                <div className="w-full p-4 bg-green-100 rounded-lg border border-green-200 mt-5  text-green-700">
                    <p className="text-sm">مرحله اول با موفقیت انجام شد.</p>
                </div>
                <OTP title="کد اعتبار سنجی دوم را وارد کنید." verifyOTPLoading={verifyRequest}
                     requestOTPLoading={requestLoading}
                     description={`لطفا کد اعتبار سنجی  برای شماره  ${serviceContext.process.platform_user} را ارسال شده است.`}
                     handleVerify={handlePasswordBusinessLicense} handleRequest={() => {
                    handleVerifyBusinessLicenseOTP(111111)
                }} timerCount={120}/>

            </>}

        </div>
    </div>
}
export default BusinessLicenseOTP